import Vue from 'vue';
export const EventBus = new Vue();

window.addEventListener("message", function (e) {
    if (e.data.action) {
        EventBus.$emit("onPostMesssage", e.data);
    }
});